var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPoker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4531V15.0391C0 16.0083 0.788555 16.7969 1.75781 16.7969H18.2422C19.2114 16.7969 20 16.0083 20 15.0391V14.4531H0Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8532 17.9688H6.14685L5.56713 19.1572C5.47853 19.3388 5.48978 19.5532 5.59685 19.7245C5.70392 19.8959 5.89174 20 6.09377 20H13.9063C14.1083 20 14.2961 19.8959 14.4032 19.7245C14.5103 19.5532 14.5215 19.3388 14.4329 19.1572L13.8532 17.9688Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 2.34375H15.0781V9.76562C15.0781 10.8426 14.202 11.7188 13.125 11.7188H6.875C5.79805 11.7188 4.92188 10.8426 4.92188 9.76562V2.34375H1.75781C0.788555 2.34375 0 3.1323 0 4.10156V13.2812H20V4.10156C20 3.1323 19.2114 2.34375 18.2422 2.34375Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31104 5.27339L9.99986 6.45425L10.6887 5.27339L9.99986 4.09253L9.31104 5.27339Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0H6.875C6.44352 0 6.09375 0.349766 6.09375 0.78125V9.76562C6.09375 10.1971 6.44352 10.5469 6.875 10.5469H13.125C13.5565 10.5469 13.9062 10.1971 13.9062 9.76562V0.78125C13.9062 0.349766 13.5565 0 13.125 0ZM11.8733 5.56867L10.5061 7.91242C10.4011 8.09246 10.2084 8.20312 10 8.20312C9.7916 8.20312 9.59887 8.09246 9.49387 7.91242L8.12668 5.56867C8.02023 5.38625 8.02023 5.16063 8.12668 4.9782L9.49387 2.63445C9.59887 2.45441 9.7916 2.34375 10 2.34375C10.2084 2.34375 10.4011 2.45441 10.5061 2.63445L11.8733 4.9782C11.9797 5.16063 11.9797 5.38625 11.8733 5.56867Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPoker);
export default __webpack_public_path__ + "static/media/Video Poker.775b461b7833403c97a4d2782aa75287.svg";
export { ForwardRef as ReactComponent };